// extracted by mini-css-extract-plugin
export var sliderRange = "_nq-2";
export var sliderRoot = "_nq-0";
export var sliderThumb = "_nq-3";
export var sliderTrack = "_nq-1";